import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFieldDirective } from './dynamic-field.directive';
import { SelectComponent } from './select/select.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { ButtonComponent } from './button/button.component';
import { InputComponent } from './input/input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AutoCompleteComponent } from './auto-complete/auto-complete.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { CheckBoxComponent } from './check-box/check-box.component';

@NgModule({
  declarations: [DynamicFieldDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AutoCompleteComponent,
    SelectComponent,
    ButtonComponent,
    InputComponent,
    RadioButtonComponent,
    CheckBoxComponent,
    DatePickerComponent,
  ],
  exports: [
    AutoCompleteComponent,
    FormsModule,
    ReactiveFormsModule,
    SelectComponent,
    DatePickerComponent,
    ButtonComponent,
    InputComponent,
    RadioButtonComponent,
    CheckBoxComponent,
    DynamicFieldDirective,
  ],
})
export class FormFieldsModule {}
